module.exports = __webpack_public_path__ + "img/img-c39495.jpg";